import { render, staticRenderFns } from "./TrackingPageClient.vue?vue&type=template&id=270feec4"
import script from "./TrackingPageClient.vue?vue&type=script&lang=js"
export * from "./TrackingPageClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports